import { useState, useEffect } from 'react'
import PubSub from 'pubsub-js'
import { gql } from '@apollo/client'
import { Alert, Table, Button } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { GET_PROFILER_RUN_DETAIL_QUERY } from '../../../graphql.js'
import { handleGraphQLErrors, publishEvent } from '../../../utils.js'

export const GET_PROFILER_RUN_DETAIL = gql(GET_PROFILER_RUN_DETAIL_QUERY)

export default function ProfilerRunDetail() {
  console.log('ProfilerRunDetail rendered')

  const [runId, setRunId] = useState()
  const [spinner, setSpinner] = useState(false)
  const [items, setItems] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  async function selectPackage(owner, name) {
    publishEvent('PACKAGE SELECTED', { owner: owner, name: name }, 'ProfilerRuns.selectPackage')
  }
 
  useEffect(() => {
    function handleRunSelected(msg, data) {
      console.log(`EVENT RECEIVED (ProfilerRunDetail): ${msg}`, data)
      setRunId(data)
      fetchDetails(data)
    }
    const eventToken = PubSub.subscribe('PROFILER RUN SELECTED', handleRunSelected)
    return function cleanup() {
      PubSub.unsubscribe(eventToken)
    }
  })

  async function fetchDetails(runId) {
    try {
      setSpinner(true)
      const { data, errors } = await window.apolloClient.query({ query: GET_PROFILER_RUN_DETAIL, variables: { runId: runId } })
      console.log('GET_PROFILER_RUN_DETAIL data: ', { data })
      if (data.getProfilerRunDetail) {
        const details = []
        for (let detail of data.getProfilerRunDetail) {
          details.push(
            <tr key={`${detail.owner}-${detail.name}`}>
              <td style={{ textAlign: 'left' }}>{detail.owner}</td>
              <td style={{ textAlign: 'left' }}><Button color='secondary' size='sm' onClick={() => selectPackage(detail.owner, detail.name)}>{detail.name}</Button></td>
              <td style={{ textAlign: 'right' }}>{detail.totalOccur}</td>
              <td style={{ textAlign: 'right' }}>{detail.totalTime}</td>
            </tr>)
        }
        setItems(details)
      }
      if (errors) {
        setGraphQLErrors(errors)
      }
    } catch (err) {
      handleGraphQLErrors(err, setGraphQLErrors)
    } finally {
      setSpinner(false)
    }
  }

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  }
  if (spinner) {
    return <Spinner />
  }
  return (
    <div style={{ marginTop: '20px', marginBottom: '40px' }}>
      <Table bordered style={{ padding: '.25rem', width: 'auto', margin: 'auto' }}>
        <thead>
          <tr>
            <th colSpan={4}>Details of Run ID: {runId}</th>
          </tr>
          <tr>
            <th style={{ textAlign: 'left' }}>Owner</th>
            <th style={{ textAlign: 'left' }}>Name</th>
            <th>Total Occur</th>
            <th>Total Time</th>
          </tr>
        </thead>
        <tbody>
          {items}
        </tbody>
      </Table>
    </div>
  )
}
